import { createContext, useContext } from 'react';
import { PostLoanApplicationResult, redirect } from '@n2-common/models';
import { NorwegianLoanApplication } from '@n2-common/components/WizardFormManager/no/fieldDefinitions';

export { LoanApplicationContextProvider as O1LoanApplicationContextProvider } from './Context.O1';

export type LoanApplicationContextType = {
    postLoanApplication: (values: NorwegianLoanApplication) => Promise<PostLoanApplicationResult>;
    redirect: typeof redirect;
};

export const LoanApplicationContext = createContext<LoanApplicationContextType | null>(null);

export function useLoanApplicationContext() {
    const context = useContext(LoanApplicationContext);
    if (!context) {
        throw new Error('useLoanApplicationContext hook is only useable in tree under LoanApplicationContextProvider element.');
    }
    return context;
}
